{
  "DE": "Alemanha",
  "AT": "Áustria",
  "BE": "Bélgica",
  "DK": "Dinamarca",
  "ES": "Espanha",
  "FR": "França",
  "IE": "Irlanda",
  "IT": "Itália",
  "LU": "Luxemburgo",
  "MC": "Mônaco",
  "NL": "Países Baixos",
  "PL": "Polônia",
  "PT": "Portugal",
  "SE": "Suécia"
}
